
export const useHeaderOffset = (name) => {
    const heroExisit = document.getElementsByClassName("section-hero");
    return heroExisit.length ? 60 : 0;
}